import {
  all,
  takeEvery,
  takeLatest,
  put,
  fork,
  select,
} from "redux-saga/effects";
import { getLabPackages } from "./labpackageActions";
import { getLabPackagesFromServer } from "./LabPackageServices";
import types from "./types";

export const getUser = (state) => state.auth;

export function* fetchLabPackage({pageNum, search, filterby, limit}) {
  console.log(pageNum, search, "pageNum");
  // let pagenum = pageNum && pageNum.pageNum;
  let SearchItem = ''
  if(search == undefined ){
      SearchItem = ""
  }
  else{
      SearchItem = search
  }
  try {
    const response = yield getLabPackagesFromServer(pageNum, SearchItem, filterby, limit);
    yield put({ type: types.GET_LAB_PACKAGE_SUCCESS, payload: response.data });
  } catch (error) {
    console.log(error);
  }
}

export function* labPackageWatcher() {
  yield takeLatest(types.GET_LAB_PACKAGE, fetchLabPackage);
}

export default function* labPackageSaga() {
  yield all([labPackageWatcher()]);
}
